import React, { useState } from "react"

import Popup from "components/Ui/Popup"
import { DeleteButton } from "./DeleteWorkflow.styled"

type Props = {
  onDelete: () => void
  loading: boolean
}

const DeleteWorkflow = ({ onDelete, loading }: Props) => {
  const [openPopup, setOpenPopup] = useState(false)

  return (
    <>
      <DeleteButton type="button" onClick={() => setOpenPopup(true)}>
        Delete
      </DeleteButton>
      {openPopup && (
        <Popup
          title="Delete workflow"
          subtitle="Are you sure you want to delete this workflow? This action cannot be undone."
          handleCloseClick={(e) => {
            e.stopPropagation()
            setOpenPopup(false)
          }}
          handleOkClick={(e) => {
            e.stopPropagation()
            onDelete()
            setOpenPopup(false)
          }}
          loading={loading}
          type="delete"
        />
      )}
    </>
  )
}

export default DeleteWorkflow
